var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"richtext",style:({ background: _vm.datas.backColor })},[(!_vm.datas.myValue.length)?_c('img',{attrs:{"draggable":"false","src":"","alt":""}}):_c('section',{domProps:{"innerHTML":_vm._s(_vm.datas.myValue)}}),_vm._t("deles")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }